import { useState } from 'react'
import mergeRefs from 'react-merge-refs'
import { OtherAvailabilityLinkButton } from '@/Reservations/Search/OtherAvailability/OtherAvailabilityLinkButton'
import { reservationWidgetMessages } from '@/reservationWidgetMessages'
import { useLocales } from '@sevenrooms/locales'
import { Button } from '@sevenrooms/ui-kit/form'
import { useMeasure, useOverflowed } from '@sevenrooms/ui-kit/hooks'
import { Box, HStack } from '@sevenrooms/ui-kit/layout'
import { SecondaryText } from '@sevenrooms/ui-kit/typography'

interface OtherAvailabilityTitleRowProps {
  title: string
  subtitle?: string
  onTitleClick: () => void
  titleDataTest?: string
  subtitleDataTest?: string
}

export function OtherAvailabilityTitleRow({
  title,
  subtitle,
  onTitleClick,
  titleDataTest,
  subtitleDataTest,
}: OtherAvailabilityTitleRowProps) {
  const { formatMessage } = useLocales()
  const [setMeasureRef, { width }] = useMeasure({ scroll: false, offsetSize: false })
  const [isTruncated, setOverflowedRef] = useOverflowed(width)
  const [shouldEnableEllipsis, setShouldEnableEllipsis] = useState(true)

  return (
    <Box minWidth="0">
      <OtherAvailabilityLinkButton onClick={onTitleClick} data-test={titleDataTest}>
        {title}
      </OtherAvailabilityLinkButton>
      {subtitle &&
        (shouldEnableEllipsis ? (
          <HStack mt="xs">
            <SecondaryText
              ref={mergeRefs([setMeasureRef, setOverflowedRef])}
              overflow="hidden"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              data-test={subtitleDataTest}
            >
              {subtitle}
            </SecondaryText>
            {isTruncated && (
              <Button
                data-test="view-more-button"
                noPadding
                variant="tertiary"
                onClick={() => {
                  setShouldEnableEllipsis(!shouldEnableEllipsis)
                }}
              >
                {formatMessage(reservationWidgetMessages.resConfirmPageViewMore)}
              </Button>
            )}
          </HStack>
        ) : (
          <Box mt="xs">
            <SecondaryText data-test={subtitleDataTest} ref={mergeRefs([setMeasureRef, setOverflowedRef])}>
              {subtitle}
            </SecondaryText>
            <Box as="span" ml="xs">
              <Button
                data-test="view-less-button"
                noPadding
                variant="tertiary"
                onClick={() => {
                  setShouldEnableEllipsis(!shouldEnableEllipsis)
                }}
              >
                {formatMessage(reservationWidgetMessages.resConfirmPageViewLess)}
              </Button>
            </Box>
          </Box>
        ))}
    </Box>
  )
}
